// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import PageEvents from './PageEvents'
import PageHeader from './PageHeader'
import Content from './Content'
import Offers from './Offers'
import DonateForm from './DonateForm'
import Posts from './Posts'
import Events from './Events'
import Event from './Event'
import VersesIntro from 'components/Verses/VersesIntro'
import VerseList from 'components/Verses/VerseList'
import VersesInfoButton from 'components/Verses/VersesInfoButton'
import VersesListButton from 'components/Verses/VersesListButton'
import VersesSchedule from 'components/Verses/VersesSchedule'
import PocketStudio from 'components/PocketStudio/PocketStudio'
import NowPlayingMobile from 'components/NowPlaying/NowPlayingMobile'
import SchedulePlayer from 'components/Schedule/SchedulePlayer'
import Profile from 'components/Auth/Profile'

class Page extends React.Component {
	componentDidMount() {
		if ( ! this.props.match ) {
			return
		}
	}

	renderLoading() {
		return (
			<div className="primary-content-inner primary-content-is-loading">

			</div>
		)
	}

	renderContent() {
		const { page, hasSeenVotdIntro, isMobile, appMode } = this.props

		if ( ! page || ( page.type != 'page' && page.type != 'post' ) ) {
			return null
		}

		const { params } = this.props.match
		let theTitle = page.title.raw

		if ( 'event' == page.post_type ) {
			theTitle = page.event_location
		}

		document.title = theTitle

		let showPageHeader = true

		if ( 'listen' == page.template && isMobile && ! appMode ) {
			showPageHeader = false
		}

		const pageContent = page.html_override ? (
			<div className="content-custom-wrap" dangerouslySetInnerHTML={ { __html: page.html_override } }></div>
		) : (
			<div>
				<PageEvents />

				{ showPageHeader &&
					<PageHeader />
				}

				{ 'listen' == page.template && isMobile && ! appMode &&
					<NowPlayingMobile />
				}

				{ 'listen' == page.template && isMobile && ! appMode &&
					<SchedulePlayer />
				}

				{ 'offers' == page.template &&
					<Offers />
				}

				{ 'donate' == page.template &&
					<DonateForm />
				}

				{ 'verse-list' == page.template &&
					[
						<Content key="Content" />,
						<VersesInfoButton key="VersesInfoButton" { ...this.props } />,
						<VerseList key="VerseList" />
					]
				|| 'votd-intro' == page.template &&
					[
						<Content key="Content" />,
						<VersesListButton key="VersesListButton" { ...this.props } />
					]
				||
					<Content />
				}

				{ 'events' == page.template &&
					<Events { ...this.props } />
				}

				{ 'event' == page.post_type &&
					<Event { ...this.props } />
				}

				{ 'votd-schedule' == page.template &&
					<VersesSchedule match={ this.props.match } />
				}

				{ 'pocket-studio' == page.template &&
					<PocketStudio />
				}

				{ 'profile' == page.template &&
					<Profile />
				}

				{ 'blog' == page.template &&
					<Posts { ...this.props } />
				}
			</div>
		)

		return (
			<div className="primary-content-inner primary-content-is-ready">
				{ pageContent }
			</div>
		)
	}

	render() {
		const { isLoading } = this.props

		return (
			<div>
				{ isLoading ? this.renderLoading() : this.renderContent() }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isLoading: state.page.isLoading,
		page: state.page.selected,
		hasSeenVotdIntro: state.site.hasSeenVotdIntro,
		isMobile: state.site.isMobile,
		appMode: state.site.appMode
	}
}

export default connect( mapStateToProps )( Page )
